import {observer} from 'mobx-react-lite'
import React, {useEffect} from 'react'
import tw from 'tailwind-styled-components'
import {useBoard, useSyncEvent} from '@containers/hooks'
import {PageService} from '@extensions/page-service'
import {Diagram} from './diagram'
import {Tasks} from './tasks'
import {useTimelineNewStore} from './timeline-new-store'

const TwWrapper = tw.div`
  bg-primary
  flex
  flex-col
  select-none
`

const TwMain = tw.div`
  flex-1
  flex
  min-h-0
`

const TwTasks = tw(Tasks)`
  h-full
`

const TwDiagram = tw(Diagram)`
  flex-1
  h-full
`

export interface TimelineNewProps {
  className?: string
}

export const TimelineNew = observer((props: TimelineNewProps) => {
  const {className} = props
  const [, store] = useTimelineNewStore()
  const board = useBoard()

  useEffect(() => {
    const id = PageService.addLocationListener(store.syncLocation)
    return () => PageService.removeLocationListener(id)
  }, [store])

  useSyncEvent(
    'current',
    {filter: board.id, debounceTime: 200},
    () => {
      if (store.calcExpandedPaths()) {
        store.calculateTableRows()
      }
    },
    [board.id]
  )

  useSyncEvent('current', {filter: '*'}, store.syncIfRequired, [store])

  return (
    <TwWrapper className={className}>
      <TwMain>
        <TwTasks />
        <TwDiagram />
      </TwMain>
    </TwWrapper>
  )
})
